<template>
  <div>
    <el-card class="box-card boxcard">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="牧场">
          <el-input v-model="formInline.cztname" placeholder="牧场"></el-input>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input v-model="formInline.ccode" placeholder="订单号"></el-input>
        </el-form-item>
        <el-form-item label="分类名称">
          <el-input v-model="formInline.cinvname" placeholder="分类名称"></el-input>
        </el-form-item>
        <el-form-item label="合同状态">
          <el-select v-model="formInline.Select1" placeholder="请选择">
            <el-option label="正在报价" value="0"></el-option>
            <el-option label="报价完毕" value="1"></el-option>
            <el-option label="停止报价" value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="订单日期">
          <el-date-picker v-model="alwaysUseStartDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <Debounce :time='300' :isDebounce="1">
            <el-button type="primary" @click.native="onSubmit" size="medium">查询</el-button>
          </Debounce>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="box-card">
      <div class="text item text-center">
        <div class="pull-right" style="margin-bottom:15px">
          <el-button type="success" size="medium" icon="el-icon-upload2">上传</el-button>
          <el-button type="info" size="medium" icon="el-icon-download">下载</el-button>
          <el-button type="primary" size="medium">确认</el-button>
          <el-button type="warning" size="medium" icon="el-icon-aim">已上传预览</el-button>
        </div>
        <el-table :data="tableData1" style="width: 100%" max-height="480" border :cell-style="{ padding: '7px 0' }">
          <el-table-column type="index" label="主键" width="50"></el-table-column>
          <el-table-column prop="content" label="确认" width="50"></el-table-column>
          <el-table-column prop="content" label="牧场" width="120"></el-table-column>
          <el-table-column prop="content" label="订单号" width="220"></el-table-column>
          <!-- <el-table-column prop="content" label="合同号" width="220"></el-table-column> -->
          <el-table-column prop="content" label="订单日期" width="120"></el-table-column>
          <el-table-column prop="content" label="送货截止日期" width="220"></el-table-column>
          <el-table-column prop="content" label="合同上传完毕" width="220"></el-table-column>
          <el-table-column prop="content" label="下载" width="90"></el-table-column>
          <el-table-column prop="content" label="合同下发日期" width="120"></el-table-column>
          <el-table-column prop="content" label="确认截止日期" width="120"></el-table-column>
          <el-table-column prop="content" label="分类名称" width="90"></el-table-column>
          <el-table-column prop="content" label="金额" width="90"></el-table-column>
          <el-table-column prop="content" label="合同推送人员" width="120"></el-table-column>
          <el-table-column prop="content" label="下载次数" width="120"></el-table-column>
          <el-table-column prop="content" label="下载时间" width="120"></el-table-column>
          <el-table-column prop="content" label="上传日期" width="120"></el-table-column>
          <el-table-column prop="content" label="允许超期上传" width="120"></el-table-column>
          <el-table-column prop="content" label="设置人" width="120"></el-table-column>
          <el-table-column prop="content" label="设置时间" width="120"></el-table-column>
          <!-- <el-table-column  label="操作" width="150">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" plain @click="read(scope.row)">查看</el-button>
        </template>
       </el-table-column> -->
        </el-table>
      </div>
    </el-card>

  </div>
</template>

<script>
export default {
  data() {
    return {
      alwaysUseStartDate: [],
      formInline: {
        cztname: "",
        ccode: "",
        cinvname: "",
        Select1: "",
        startDate: "",
        endDate: "",
      },
      notvisi: false,
      NoticeDel: {},
      tableData1: [
        {
          content: "报价单",
          title: "报价单",
        },
        {
          content: "待确认订单",
          title: "待确认订单",
        },
      ],
    };
  },
  created() {},
  methods: {
    onSubmit() {
      console.log("submit!");
    },
    notvisiif(val) {
      this.notvisi = val;
    },
    read(val) {
      this.notvisi = true;
      this.NoticeDel = val;
    },
  },
};
</script>


